export default __webpack_public_path__ + "media/images/ui-icons_2e83ff_256x240-71a38993daaa97d99622d32e16376e74.png";